export default {
  LIST_FETCHED: 'DENTAL_FETCHED',
  LIST_LOAD: 'DENTAL_LOAD',
  ITEM_DETAIL: 'DENTAL_DETAIL',
  BUTTON_LOAD: 'DENTAL_BUTTON_LOAD',
  NEWS_LIST_FETCHED: 'DENTAL_NEWS_FETCHED',
  NEWS_LIST_LOAD: 'DENTAL_NEWS_LOAD',
  NEWS_LIST_SET: 'DENTAL_NEWS_SET',
};
